// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderStatus,
    ProviderStatusSortType,
    SupportCreateStatusPayload,
    SupportStatus,
    SupportStatusSortType,
    SupportCreateStatusPayloadToJSON,
    ProviderStatusFromJSON,
    SupportStatusFromJSON,
} from '../models';

export interface CreateSupportStatusRequest {
    supportCreateStatusPayload: SupportCreateStatusPayload;
}

export interface GetProviderStatusRequest {
    id: string;
}

export interface GetSupportStatusRequest {
    id: string;
}

export interface ListProviderStatusesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderStatusesOrderEnum>;
    filterCreated?: Array<string>;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterClaimControlNumber?: Array<string>;
    filterPatientControlNumber?: Array<string>;
    sort?: Array<ProviderStatusSortType>;
}

export interface ListSupportStatusesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportStatusesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterClaimId?: Array<string>;
    filterProfessionalId?: Array<string>;
    filterInstitutionalId?: Array<string>;
    filterDentalId?: Array<string>;
    filterNynf3Id?: Array<string>;
    filterClaimControlNumber?: Array<string>;
    filterPatientControlNumber?: Array<string>;
    sort?: Array<SupportStatusSortType>;
}

/**
 * no description
 */
export class StatusApi extends runtime.BaseAPI {

    /**
     * Create a claim status
     * Create a claim status
     */
    async createSupportStatusRaw(requestParameters: CreateSupportStatusRequest): Promise<runtime.ApiResponse<SupportStatus>> {
        if (requestParameters['supportCreateStatusPayload'] === null || requestParameters['supportCreateStatusPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateStatusPayload','Required parameter requestParameters.supportCreateStatusPayload was null or undefined when calling createSupportStatus.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:status", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateStatusPayloadToJSON(requestParameters['supportCreateStatusPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportStatusFromJSON(jsonValue));
    }

    /**
     * Create a claim status
     * Create a claim status
     */
    async createSupportStatus(requestParameters: CreateSupportStatusRequest): Promise<SupportStatus> {
        const response = await this.createSupportStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim status
     * Retrieve a claim status
     */
    async getProviderStatusRaw(requestParameters: GetProviderStatusRequest): Promise<runtime.ApiResponse<ProviderStatus>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderStatus.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:status"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/status/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderStatusFromJSON(jsonValue));
    }

    /**
     * Get a claim status
     * Retrieve a claim status
     */
    async getProviderStatus(requestParameters: GetProviderStatusRequest): Promise<ProviderStatus> {
        const response = await this.getProviderStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a claim status
     * Retrieve a claim status
     */
    async getSupportStatusRaw(requestParameters: GetSupportStatusRequest): Promise<runtime.ApiResponse<SupportStatus>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportStatus.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:status", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/status/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportStatusFromJSON(jsonValue));
    }

    /**
     * Get a claim status
     * Retrieve a claim status
     */
    async getSupportStatus(requestParameters: GetSupportStatusRequest): Promise<SupportStatus> {
        const response = await this.getSupportStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * List claim statuses
     * List claim statuses
     */
    async listProviderStatusesRaw(requestParameters: ListProviderStatusesRequest): Promise<runtime.ApiResponse<Array<ProviderStatus>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterClaimControlNumber) {
            queryParameters['filterClaimControlNumber'] = requestParameters.filterClaimControlNumber;
        }

        if (requestParameters.filterPatientControlNumber) {
            queryParameters['filterPatientControlNumber'] = requestParameters.filterPatientControlNumber;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:status"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderStatusFromJSON));
    }

    /**
     * List claim statuses
     * List claim statuses
     */
    async listProviderStatuses(requestParameters: ListProviderStatusesRequest): Promise<Array<ProviderStatus>> {
        const response = await this.listProviderStatusesRaw(requestParameters);
        return await response.value();
    }

    /**
     * List claim statuses
     * List claim statuses
     */
    async listSupportStatusesRaw(requestParameters: ListSupportStatusesRequest): Promise<runtime.ApiResponse<Array<SupportStatus>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterProfessionalId) {
            queryParameters['filterProfessionalId'] = requestParameters.filterProfessionalId;
        }

        if (requestParameters.filterInstitutionalId) {
            queryParameters['filterInstitutionalId'] = requestParameters.filterInstitutionalId;
        }

        if (requestParameters.filterDentalId) {
            queryParameters['filterDentalId'] = requestParameters.filterDentalId;
        }

        if (requestParameters.filterNynf3Id) {
            queryParameters['filterNynf3Id'] = requestParameters.filterNynf3Id;
        }

        if (requestParameters.filterClaimControlNumber) {
            queryParameters['filterClaimControlNumber'] = requestParameters.filterClaimControlNumber;
        }

        if (requestParameters.filterPatientControlNumber) {
            queryParameters['filterPatientControlNumber'] = requestParameters.filterPatientControlNumber;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:status", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportStatusFromJSON));
    }

    /**
     * List claim statuses
     * List claim statuses
     */
    async listSupportStatuses(requestParameters: ListSupportStatusesRequest): Promise<Array<SupportStatus>> {
        const response = await this.listSupportStatusesRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderStatusesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportStatusesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
